import { z } from 'zod';
/**
 * BriefAction — closed set of 14 verbs a user can take on a brief item.
 * Used by the `<ItemMenu>` design-system primitive's `actions` prop and
 * by the `BRIEF.*` audit event verbs in the action ledger (per issue
 * #166 comment A).
 *
 * The verbs cover the full lifecycle of a brief item:
 *
 *   open       — open the source / detail view
 *   approve    — accept the agent's recommendation
 *   decline    — reject the agent's recommendation
 *   defer      — push to tomorrow's brief
 *   drill-in   — expand into the dossier / synthesis sources
 *   pin-note   — pin a personal note to the item
 *   comment    — leave a comment for the next read
 *   share      — share the item with a teammate
 *   correct    — tell the agent it got something wrong (wires FB-06)
 *   re-rank    — explicitly down/up-weight similar items
 *   replay     — replay the agent's reasoning trace
 *   compare    — open a dossier-comparison view
 *   resend     — re-trigger any drafted email/Slack send
 *   archive    — remove from briefs without a verdict
 */
export const BriefAction = z.enum([
    'open',
    'approve',
    'decline',
    'defer',
    'drill-in',
    'pin-note',
    'comment',
    'share',
    'correct',
    're-rank',
    'replay',
    'compare',
    'resend',
    'archive',
]);
